import React, { Component } from "react";

import {
  HomeSlider,
  HomeDeals,
  VideoSliderItem,
  PostSliderItem,
  HomeTitle,
  ResponsiveYouTubeIframe,
  CoverSection,
} from "../../Components/UI/UI";

import { newPosts, TouristInfoPosts } from "../../Data/Data";
import { newPostdata } from "../../Posts/PostsData";
import { getWeather, getUrl } from "../../Utility/Utility";
import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";

import "../innerPage.css";
import "./SearchPage.css";

const getParam = window.location.search;
// console.log(typeof getParam);
// console.log(getParam);
const urlParams = new URLSearchParams(getParam);
const keyWord = urlParams.get("q");
// console.log(typeof keyWord);

class SearchPage extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
    keyWord: keyWord,
    isResult: false,
  };

  componentDidMount() {
    getWeather((Weather) => {
      this.setState({
        telAvivWeather: Weather.telAvivWeather,
        waterTemp: Weather.water_temp,
        jerusalemWeather: Weather.jerusalemWeather,
      });
    });
  }

  render() {
    // console.log('typeOf keyword:', typeof this.state.keyWord);
    // console.log('this.state.keyWordTTTTTTTTT:', this.state.keyWord);
    const lowerCaseKeyWord = this.state.keyWord;
    const toLowerCaseKeyWord = lowerCaseKeyWord.toLowerCase();

    const noResults = "Soory, no results";

    // get all posts

    const posts = [...newPosts, ...TouristInfoPosts];

    // console.log('posts:', posts);

    const d = [...newPostdata];

    let searchResults = posts.map((o, i) => {
      // console.log('o:',o);

      let url = null;
      let html = null;
      let component = null;
      let cssClass = "";
      let category = o.ctg;
      let title = o.title;
      let ids = o.id;

      //  console.log('toLowerCaseKeyWord:', toLowerCaseKeyWord);

      if (
        category.includes(this.state.keyWord) ||
        title.includes(this.state.keyWord) ||
        category.includes(toLowerCaseKeyWord) ||
        title.includes(toLowerCaseKeyWord)
      ) {
        if (o.isVid === true) {
          url = "/Posts/Videos/" + o.ctg + "/" + o.id;
          component = (
            <VideoSliderItem
              key={i}
              title={o.title}
              desc={""}
              img={o.img}
              link={url}
              cssClass={cssClass}
            />
          );
        } else {
          // url = "/Posts/" + o.id ;
          url = "/Posts/" + o.ctg + "/" + o.id;
          component = (
            <PostSliderItem
              key={i}
              title={o.title}
              desc={""}
              img={o.img}
              link={url}
              cssClass={cssClass}
            />
          );
        }

        return component;
      }
    });

    let dd = d.map((o, i) => {
      const ht = o.html();
      // console.log('ht.__html:', ht.__html);
      let h = ht.__html;
      h = h.toLowerCase();
      // console.log('h:', h);

      let url = null;
      let html = null;
      let component = null;
      let cssClass = "";
      let category = o.ctg;
      let title = o.title;
      let ids = o.id;

      const current = posts.filter((objj) => {
        return objj.id === o.id;
      });

      if (current.length > 0) {
        const c = current[0];
        //  console.log(h.length);
        //  console.log(h);
        //  console.log( 'includes' , h.includes(this.state.keyWord.trim()));

        const regex = /this.state.keyWord/g;
        const found = h.match(regex);
        // console.log('foundfoundfound', found);
        // alert(h.includes(this.state.keyWord))

        if (
          h.includes(this.state.keyWord.trim()) == true ||
          category.includes(this.state.keyWord) ||
          title.includes(this.state.keyWord) ||
          category.includes(toLowerCaseKeyWord) ||
          title.includes(toLowerCaseKeyWord)
        ) {
          if (o.isVid === true) {
            url = "/Posts/Videos/" + o.ctg + "/" + o.id;
            component = (
              <VideoSliderItem
                key={i}
                title={c.title}
                desc={""}
                img={c.img}
                link={url}
                cssClass={cssClass}
              />
            );
          } else {
            // url = "/Posts/" + o.id ;
            url = "/Posts/" + o.ctg + "/" + o.id;
            component = (
              <PostSliderItem
                key={i}
                title={c.title}
                desc={""}
                img={c.img}
                link={url}
                cssClass={cssClass}
              />
            );
          }

          return component;
        }
      }
    });

    // console.log('dd' , dd);

    searchResults = [...searchResults, ...dd];

    searchResults = searchResults.filter(function(el) {
      return el != null;
    });

    // console.log('searchResults' , searchResults);

    return (
      <div className="inner-page align-center page-searchpage">
        <Menu />

        <CoverSection
          desktopImg={"/posts/bank/page-search/1.jpg"}
          mobileImg={"/posts/bank/page-search/M.jpg"}
          cssClass={"telaviv"}
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />

        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>Search results</HomeTitle>

            <div className="live-shows-wrapper">
              {searchResults.length == 0 ? (
                <h3>Soory, no results</h3>
              ) : (
                searchResults
              )}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

export default SearchPage;



// WEBPACK FOOTER //
// ./src/Pages/SearchPage/SearchPage.js